//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { commonApi } from '@/common/index';
  import loadMore from '@/common/components/load-more/'
  import noData from '@/common/components/noData/index.vue'
  export default {
    components: { loadMore, noData },
    data() {
      return {
        article: { title: '', typeId: '' },
        page: { pageNo: 1, pageSize: 10 },
        list: [],
        total: null
      }
    },
    created() {
      const { name, id, lang  } = this.$route.query
      this.article = { title: name, typeId: id }
      if (lang) this.article.lang = lang
      this._getContent()
    },
    methods: {
      loadmore({ finish, params }) {
        if (this.list.length === this.total) {
          this.$vux.toast.show({ text: this.$t('others').noData1, type: 'cancel' });
          finish()
          return
        }
        this.page.pageNo += 1
        this._getContent(finish)
      },
      _getContent(finish) {
        const params = {
          frontType: this.$store.state.frontType,
          typeId: this.article.typeId,
          ...this.page
        }
        if (this.article.lang) params.lang = this.article.lang
        commonApi.HELP.getArticleListByType(params).then((data) => {
          const { total, list } = data
          this.list = this.page.pageNo === 1 ? list : [...this.list, ...list]
          this.total = total
          if (finish) finish()
        }).catch(err=>{
          this._reset()
          if (finish) finish()
        })
      },
      _reset() {
        if (this.page.pageNo === 1) {
          this.list = []
          this.total = 0
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/Service/Problems/details.vue